module.exports = __webpack_public_path__ + "static/media/work1.99e4d18c.jpg";